module.exports = __webpack_public_path__ + "img/SICOM2020.4d5f8fb3.png";